import InvitesTab from './InvitesTab';

export default InvitesTab;
